<template>
  <!-- 运营车辆管理 -->
  <div>
    <div id="bk1" style="display: none" class="bk1"></div>
    <div id="openImg" style="display: none" class="openImg">
      <div class="a" @click="open()"></div>
      <div class="all">
        <span>资料下载</span>
        <table>
          <tr>
            <th>文件名称</th>
            <th>文件格式</th>
            <th>文件大小</th>
            <th>操作</th>
          </tr>
          <tr v-for="(person, index) in arr" :key="index">
            <td>
              <div>{{ person.fileName }}</div>
            </td>
            <td>
              <div>{{ person.fileFormat }}</div>
            </td>
            <td>
              <div>{{ person.fileSize }}</div>
            </td>
            <td>
              <img
                @click="download(person.url, person.fileName)"
                src="../assets/img/icon_download_mob.png"
                alt=""
              />
            </td>
          </tr>
        </table>
      </div>
    </div>

    <div class="bk"></div>
    <div class="top">
      <div class="title">运营车辆管理</div>
      <div class="content">
        般极活性济众己率况八史次等较音与县断青话号选子次成流加约元派产王日线消精军知比口门对每眼形过政保经同改金特极近那性京段元物土机亲气细调治。
      </div>
      <div class="smart">SMART</div>
    </div>
    <div class="topImg"></div>
    <div class="cecurity">
      <div class="title">运营车辆管理</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="cecurityImg"></div>
    <div class="cecurity2">
      <div class="title">运营车辆管理</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="cecurity2Img"></div>
    <div class="bottom">
      <div class="title">运营车辆管理</div>
      <div class="content">
        <span
          >智能安防系统可以简单理解为：图像的传输和存储、数据的存储和处理准确而选择性操作的技术系统。就智能化安防系统来说，一个完整的智能安防系统主要包括门禁、报警和监控三大部分。</span
        >
      </div>
    </div>
    <div class="phone">联系电话：0755-83932176</div>
    <div class="address">地址：深圳市盐田区沙头角深盐路保发大厦5楼整层</div>
    <!-- <div class="down" @click="open()">
      <span>下载资源</span>
      <img src="../assets/img/icon_more.svg" alt="" />
    </div> -->
    <div class="bm">
      <span>
        版权所有©深圳昌恩智能股份有限公司　
        <a style="color: #fff" target="_blank" href="http://beian.miit.gov.cn"
          >粤ICP备17113788号</a
        ></span
      >
    </div>
  </div>
</template>

<script>
export default {
  name: 'administration',
  data () {
    return {
      arr: []
    }
  },
  mounted () {
    this.toggle()
  },
  methods: {
    open () {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      if (scrollTop > 0) {
        document.documentElement.scrollTop = document.body.scrollTop = 0
      }
      var nowStatus = document.getElementById('bk1')
      var bkStatus = document.getElementById('openImg')
      console.log('=======' + nowStatus.style.display)
      if (nowStatus.style.display == 'none') {
        console.log('進來none')
        nowStatus.style.display = 'block'
        bkStatus.style.display = 'block'
      } else {
        console.log('block')
        nowStatus.style.display = 'none'
        bkStatus.style.display = 'none'
      }
    },
    toggle () {
      this.request.get('/information/6', {}).then(res => {
        console.log(res.data.data)
        this.arr = res.data.data
      })
    },
    download (url, fileName) {
      console.log(fileName + '@@@@@@@')

      // let a=document.createElement('a')
      // a.style.display='none'
      // a.href=url
      // document.body.appendChild(a)
      // a.click()
      // document.body.removeChild(a)

      // const blobUrl = window.URL.createObjectURL(url);
      // const a = document.createElement('a');
      // a.href = blobUrl;
      // a.download = fileName;
      // a.click();
      // window.URL.revokeObjectURL(url);

      const element = document.createElement('a')
      element.setAttribute('download', fileName)
      let binaryData = []
      binaryData.push(url)
      element.setAttribute(
        'href',
        window.URL.createObjectURL(new Blob(binaryData))
      )
      document.body.appendChild(element)
      element.click()
      document.body.removeChild(element)

      // window.open(url);
    }
  }
}
</script>

<style scoped>
.bk1 {
  position: absolute;
  width: 100vw;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.77);
  display: none;
}
.openImg {
  display: none;
  position: absolute;
  z-index: 12;
}
.openImg .a {
  width: 4.2667vw;
  height: 4.2667vw;
  float: right;
  margin-left: 91.4667vw;
  background-image: url(../assets/img/icon_close@2x.png);
  background-size: 100% 100%;
}
.openImg .all {
  margin-top: 12vw;
  margin-left: 4vw;
  width: 92vw;
  background-color: #ffffff;
}
.openImg .all span {
  display: block;
  padding-left: 8vw;
  font-size: 3.7333vw;
  color: rgba(0, 0, 0, 0.58);
  line-height: 10.6667vw;
  height: 10.6667vw;
}
.openImg .all table {
  border-collapse: collapse;
  width: 84vw;
  margin-left: 4vw;
}
tr {
  border-bottom: 1px dashed #000000;
}
th {
  width: 22.1333vw;
  height: 10.6667vw;
  pdding-left: 4vw;
  color: rgba(0, 0, 0, 0.58);
  opacity: 0.58;
  font-size: 3.2vw;
  font-weight: 500;
  text-align: center;
  vertical-align: middle;
}

td {
  text-align: center;
  vertical-align: middle;
}
td div {
  width: 22.1333vw;
  height: 10.6667vw;
  pdding-left: 4vw;
  line-height: 10.6667vw;
  opacity: 0.58;
  font-size: 3.2vw;
  line-height: 10.6667vw;
  text-align: center;
  vertical-align: middle;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.44);
  overflow: hidden;
}
.bk {
  position: relative;
  width: 100vw;
  height: 34.6667vw;
  background-image: url(../assets/img/智能安防_banner_mob.png);
  background-size: 100% 100%;
}
.top {
  position: relative;
  width: 100vw;
  height: 53.3333vw;
}
.top .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 16.6667vw;
  color: #140047;
  letter-spacing: 1.8293vw;
  line-height: 8vw;
  font-size: 6.4vw;
}
.top .content {
  text-align: center;
  padding-top: 29.3333vw;
  margin-left: 5.3333vw;
  width: 89.3333vw;
  height: 16vw;
  opacity: 0.72;
  font-size: 3.2vw;
  letter-spacing: 0.1333vw;
  line-height: 5.3333vw;
  color: #01021b;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.top .smart {
  position: absolute;
  left: 10.4vw;
  top: 7.8667vw;
  color: #fafafa;
  font-size: 21.3333vw;
  letter-spacing: 0.64vw;
  line-height: 24.5333vw;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  z-index: -1;
}
.topImg {
  background-image: url(../assets/img/智能安防_下载资源1_mob.png);
  background-size: 100% 100%;
  margin: 5.3333vw auto 0;
  width: 92vw;
  height: 69.0667vw;
  /* border: 1px dashed #808080; */
}

.cecurity {
  position: relative;
  margin: 14.6667vw auto;
  width: 92vw;
  height: 42.1333vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.cecurity .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
}
.cecurity .content {
  padding-top: 18.4vw;
  text-align: center;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
}
.cecurity .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #01021b;
  opacity: 0.72;
}
.cecurityImg {
  width: 92vw;
  height: 68.8vw;
  margin: 5.3333vw auto 0;
  background-image: url(../assets/img/智能安防_下载资源2_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}

.cecurity2 {
  position: relative;
  margin: 14.6667vw auto 0;
  width: 92vw;
  height: 42.1333vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.cecurity2 .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
}
.cecurity2 .content {
  text-align: center;
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
  opacity: 0.72;
}
.cecurity2 .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #01021b;
  opacity: 0.72;
}
.cecurity2Img {
  width: 92vw;
  height: 68.8vw;
  margin: 5.3333vw auto;
  background-image: url(../assets/img/智能安防_下载资源2_mob.png);
  background-size: 100% 100%;
  /* border: 1px dashed #808080; */
}

.bottom {
  position: relative;
  margin: 14.6667vw auto 0;
  width: 92vw;
  height: 42.1333vw;
  box-shadow: 0px 1px 10px 0px rgba(176, 183, 213, 0.2);
}

.bottom .title {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  padding-top: 7.4667vw;
  height: 6.4vw;
  margin: 0 auto;
  font-size: 5.0667vw;
  letter-spacing: 0.2667vw;
  line-height: 6.4vw;
  font-family: AlibabaPuHuiTiB;
  color: #140047;
}
.bottom .content {
  text-align: center;
  padding-top: 18.4vw;
  margin: 0 auto;
  width: 84.2667vw;
  height: 16vw;
  color: #01021b;
  opacity: 0.72;
}
.bottom .content span {
  /* Transform的 scale属性不能作用于 inline元素上，例如span */
  display: inline-block;
  width: 168vw;
  height: 32vw;
  font-size: 5.3333vw;
  letter-spacing: 0.2667vw;
  line-height: 10.6667vw;
  transform: scale(0.5);
  transform-origin: left;
  transform-origin: 0% 0%;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #01021b;
  opacity: 0.72;
}
.phone {
  margin-top: 4.2667vw;
  text-align: center;
  letter-spacing: 0.1333vw;
  line-height: 4.4vw;
  font-size: 3.2vw;
  color: #140047;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.address {
  margin-top: 2.1333vw;
  text-align: center;
  letter-spacing: 0.1333vw;
  line-height: 4.4vw;
  font-size: 3.2vw;
  color: #140047;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.down {
  margin-top: 4.2667vw;
  margin-left: 35.3333vw;
  width: 29.3333vw;
  height: 8vw;
  border-radius: 0.5333vw;
  background: rgba(255, 255, 255, 0.2);
  border: 1px solid #140047;
}
.down span {
  display: block;
  font-size: 3.2vw;
  line-height: 3.7333vw;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #140047;
  padding-left: 4.2667vw;
  padding-top: 2.4vw;
  float: left;
}
.down img {
  float: left;
  width: 8vw;
  height: 8.5333vw;
  margin-left: 2.6667vw;
}
</style>



// WEBPACK FOOTER //
// src/components/administration.vue